import React from "react";
import { connect } from "react-redux";
import { rotateElement } from "../../../../actions";
import { bindActionCreators } from "redux";
import RotateIcon from "../../../Layout/Icons/RotateIcon";
import RotateIconRight from "../../../Layout/Icons/RotateIconRight";
import { countSelectedElements } from "../../../common/design";

class Rotate extends React.Component {
  handleRotate = (direction) => {
    this.props.rotateElement({ direction: direction });
  };

  render() {
    const layers = this.props.layers,
      numSelectedElements = countSelectedElements(layers),
      disabled = numSelectedElements === 0;

    return (
      <div className="control__container">
        <button
          className="control__button button button--canvas button--rotate"
          onClick={() => this.handleRotate("left")}
          disabled={disabled}
        >
          <RotateIcon />
        </button>
        <div className="control__title">Rotate 5&deg;</div>
        <button
          className="control__button button button--canvas button--rotate"
          onClick={() => this.handleRotate("right")}
          disabled={disabled}
        >
          <RotateIconRight />
        </button>
        <div className="control__title">Rotate 5&deg;</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    layers: state.design.present.layer_set,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      rotateElement,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Rotate);
